import * as React from "react";

function EditIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" {...props}>
      <path
        d="M13.684 2.56L11.434.315a1.074 1.074 0 00-1.52 0L.761 9.503l-.74 3.204a1.07 1.07 0 001.047 1.286c.082.01.165.01.247 0l3.237-.713 9.131-9.2a1.073 1.073 0 000-1.52zM3.86 12.048l-2.443.54.568-2.419 6.888-6.922 1.882 1.879-6.895 6.922zm7.65-7.675l-1.883-1.88 1.035-1.052 1.895 1.892-1.048 1.04z"
        fill="#4BA3D1"
      />
    </svg>
  );
}

const MemoEditIcon = React.memo(EditIcon);
export default MemoEditIcon;
